import { Routes } from "@angular/router";
import { LoginComponent } from "./login/login.component";
import { ResetPasswordComponent } from './reset-password/ResetPasswordComponent';
import { TrialComponent } from "./trial/trial.component";
import { TrialSuccessComponent } from "./trial-success/trial-success.component";
import { ShowTrialComponent } from "./show-trial/show-trial.component";
import { DemoSuccessComponent } from "./demo-success/demo-success.component";
import { PublicAuditComponent } from "./public-audit/public-audit.component";
import { OptOutComponent } from "./public-audit/opt-out/opt-out.component";

export const PUBLIC_ROUTES: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'resetpassword', component: ResetPasswordComponent },
    { path: 'trial', component: TrialComponent },
    { path: 'showtrial', component: ShowTrialComponent },
    { path: 'trialstart', component: TrialSuccessComponent },
    { path: 'demothanks', component: DemoSuccessComponent },
    { path: 'entryform', component: PublicAuditComponent },
    { path: 'optout', component: OptOutComponent },
];
